import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';

const styles = () => ({
  root: {
  },
  container: {
  },
  oldText: {
    textDecoration: 'line-through',
    fontWeight: '700',
  },
  newText: {
    fontWeight: '700',
  },
});

const LogDifferences = ({
  className,
  classes,
  collection,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <ul>
        {collection.resources().list().map((resource) => (
          <li key={resource.id()}>
            <Box className={classes.container}>
              <Typography weight={'bold'}>
                {resource.attr('attributeName')}
              </Typography>
              <Typography color={'red'} className={classes.oldText}>
                {resource.attr('oldValue')}
              </Typography>
              <Typography color={'accentGreen'} className={classes.newText}>
                {resource.attr('newValue')}
              </Typography>
            </Box>
          </li>
        ))}
      </ul>
    </Box>
  );
};

LogDifferences.defaultProps = {
  className: '',
};

LogDifferences.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};

export default withStyles(styles)(LogDifferences);
